import React from 'react'
import { Alert, AlertTitle, Button, Box } from '@mui/material'

export interface ErrorDisplayProps {
  /** The error message to display */
  error: string
  /** Optional callback when user clicks retry */
  onRetry?: () => void
  /** Severity level of the alert */
  severity?: 'error' | 'warning' | 'info' | 'success'
  /** Custom title (defaults based on severity) */
  title?: string
  /** Custom retry button label */
  retryLabel?: string
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  onRetry,
  severity = 'error',
  title,
  retryLabel = 'Retry',
}) => {
  const defaultTitle = () => {
    switch (severity) {
      case 'error':
        return 'Error'
      case 'warning':
        return 'Warning'
      case 'info':
        return 'Info'
      case 'success':
        return 'Success'
      default:
        return 'Error'
    }
  }

  return (
    <Box>
      <Alert
        severity={severity}
        action={
          onRetry && (
            <Button color="inherit" size="small" onClick={onRetry}>
              {retryLabel}
            </Button>
          )
        }
      >
        <AlertTitle>{title || defaultTitle()}</AlertTitle>
        {error}
      </Alert>
    </Box>
  )
}
